import { useState } from "react";
import styled from "styled-components";
import CardHeader from "../CardHeader/CardHeader";
import CustomTextBox from "../CustomTextBox/CustomTextBox";
import CustomButton from "../CustomButton/CustomButton";
import theme from "../../theme/theme";
import { Auth } from "aws-amplify";
import CustomAlertLabel from "../CustomAlertLabel/CustomAlertLabel";
import CustomModal from "../CustomModal/CustomModal";
import { verifyOTP, passwordRegex } from "../../Regex";
import LoadingBar from "../LoadingBar/LoadingBar";

const BodyWrapper = styled.div`
  text-align: left;

  .inputBoxSection {
    margin-top: 7%;
  }

  .buttonContainer {
    text-align: right;
    margin-top: 7%;
  }

  .disclaimer {
    text-align: center;
    width: 100%;
    margin-top: 4%;
  }

  .linkButton {
    text-decoration: underline;
    color: ${theme.colors.primaryStrong};
    font-weight: 700;
    cursor: pointer;
  }
`;

const Header = styled.h2`
  font-size: 30px;
  font-weight: 700;
  color: ${theme.colors.primaryStrong2X};
`;

const EnterVerificationCode = (props) => {
  const [customAlertMessage, setCustomAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(isLoading);
  const [otp, setOTP] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [customModalProps, setCustomModalProps] = useState({
    isVisible: false,
    headerMessage: "",
    subHeaderMessage: "",
    primaryButtonText: "",
  });

  const handleCustomModalOnClose = () => {
    setCustomModalProps((state) => ({
      ...state,
      isVisible: false,
    }));
  };

  const handleSendAnotherCodeClick = async () => {
    setIsLoading(true);
    await Auth.forgotPassword(props.mailId);
    setIsLoading(false);
    setCustomModalProps((state) => ({
      ...state,
      isVisible: true,
      headerMessage: "Mail sent successfully",
      subHeaderMessage: "",
      primaryButtonText: "Ok",
    }));
  };

  const handleCustomTextBoxOnBlur = (textBoxName, value) => {
    if (textBoxName === "otp") {
      setOTP(value);
    } else if (textBoxName === "password") {
      setPassword(value);
    } else if (textBoxName === "confirmPassword") {
      setConfirmPassword(value);
    }
  };

  const handleCustomTextBoxKeyPress = (event) => {
    if (event.key === "Enter") {
      handleConfirmChangeClick();
    }
  };

  const handleConfirmChangeClick = async () => {
    if (!otp || !password || !confirmPassword) {
      setCustomAlertMessage("All the fields are mandatory");
      return;
    }
    if (password !== confirmPassword) {
      setCustomAlertMessage("Confirm password is not matching");
      return;
    }
    setCustomAlertMessage("");
    try {
      setIsLoading(true);
      await Auth.forgotPasswordSubmit(props.mailId, otp, password);
      props.passwordChangeSuccessful();
    } catch (error) {
      //error -  CodeMismatchException: Code is not valid.
      if (error.name === "CodeMismatchException") {
        setIsLoading(false);
        setCustomModalProps((state) => ({
          ...state,
          isVisible: true,
          headerMessage:
            error.message || "Something went wrong please try again",
          subHeaderMessage: "Please check your email",
          primaryButtonText: "Ok",
        }));
      }
    }
  };

  const handleCustomModalPrimaryButtonClick = () => {
    if (customModalProps.primaryButtonText === "Ok") {
      setCustomModalProps((state) => ({
        ...state,
        isVisible: false,
      }));
    }
  };

  return (
    <BodyWrapper>
      {(isLoaded || isLoading) && (
        <LoadingBar isLoading={isLoading} setIsLoaded={setIsLoaded} />
      )}
      {customModalProps.isVisible && (
        <CustomModal
          onClose={handleCustomModalOnClose}
          headerMessage={customModalProps.headerMessage}
          subHeaderMessage={customModalProps.subHeaderMessage}
          primaryButtonText={customModalProps.primaryButtonText}
          onClick={handleCustomModalPrimaryButtonClick}
        />
      )}
      <CardHeader text={"Verification Code"} />
      <div className="inputBoxSection">
        <span>
          An email has been sent to your account. Please enter your verification
          code to reset your password.
        </span>
      </div>
      <div className="inputBoxSection">
        <CustomTextBox
          placeholder="Enter your verification code"
          errorMessage="Not a valid OTP"
          name="otp"
          regexCode={verifyOTP}
          onBlur={handleCustomTextBoxOnBlur}
          onKeyPress={handleCustomTextBoxKeyPress}
        />
      </div>
      <div className="disclaimer">Didn’t receive an email?</div>
      <div className="disclaimer">
        <span className="linkButton" onClick={handleSendAnotherCodeClick}>
          Send another code
        </span>
      </div>
      <Header>Reset Password</Header>
      <div className="inputBoxSection">
        <CustomTextBox
          placeholder="Password"
          errorMessage="Password should contain at least 8 character, 1 uppercase, 1 lowercase character, 1 number and 1 special character"
          name="password"
          type={"password"}
          regexCode={passwordRegex}
          onBlur={handleCustomTextBoxOnBlur}
          onKeyPress={handleCustomTextBoxKeyPress}
        />
      </div>
      <div className="inputBoxSection">
        <CustomTextBox
          placeholder="Confirm Password"
          errorMessage="Not a valid password"
          name="confirmPassword"
          type={"password"}
          regexCode={passwordRegex}
          onKeyPress={handleCustomTextBoxKeyPress}
          onBlur={handleCustomTextBoxOnBlur}
        />
      </div>
      <div className="buttonContainer">
        <CustomButton
          text={"Confirm Change"}
          onClick={handleConfirmChangeClick}
        />
        <CustomAlertLabel message={customAlertMessage} />
      </div>
    </BodyWrapper>
  );
};

export default EnterVerificationCode;
